'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createDeviceInfoFromCookies = exports.createDeviceInfoFromHeader = undefined;

var _DeviceInfo = require('./DeviceInfo');

var _DeviceInfo2 = _interopRequireDefault(_DeviceInfo);

var _getCookie = require('./getCookie');

var _getCookie2 = _interopRequireDefault(_getCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Parse device header.
 * @param {string} deviceHeader - plain cookies as string
 * @param {Function} onError - handles parsing error
 * @returns  {DeviceInfo}   The device info extracted from the cookie.
 */
var createDeviceInfoFromHeader = exports.createDeviceInfoFromHeader = function createDeviceInfoFromHeader(deviceHeader, onError) {
    var deviceInfo = new _DeviceInfo2.default();
    try {
        if (deviceHeader) {
            deviceInfo.setup(JSON.parse(deviceHeader));
        }
    } catch (e) {
        onError(e);
    }
    return deviceInfo;
};
/**
 * Unserialise the cookie.
 * @param {string} cookies - plain cookies as string
 * @param {Function} onError - handles parsing error
 * @returns  {DeviceInfo}   The device info extracted from the cookie.
 */
var createDeviceInfoFromCookies = exports.createDeviceInfoFromCookies = function createDeviceInfoFromCookies(cookies, onError) {
    var deviceInfo = new _DeviceInfo2.default();
    try {
        var whDevice = (0, _getCookie2.default)(cookies)('wh_device');
        if (whDevice) {
            deviceInfo.setup(JSON.parse(whDevice));
        }
    } catch (e) {
        onError(e);
    }
    return deviceInfo;
};
/**
 * Logs errors to console
 * @param {Error} e - an error result of parsing the cookies to data.
 * @returns {void}
 */
var logDeviceError = function logDeviceError(e) {
    return console.log('DeviceInfo: ', e);
};

var savedDeviceInfo = null;

/**
 * Make it happen!
 *
 * @returns  {DeviceInfo}   The device info extracted from the cookie.
 */
var getDeviceInfo = function getDeviceInfo() {
    if (savedDeviceInfo === null) {
        savedDeviceInfo = createDeviceInfoFromCookies(window.document.cookie, logDeviceError);
    }
    return savedDeviceInfo;
};

exports.default = getDeviceInfo;
//# sourceMappingURL=deviceDetector.js.map